import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import FoundersDashboard from "@/pages/FoundersDashboard";
import SuppliersDashboard from "@/pages/SuppliersDashboard";
import UsersDashboard from "@/pages/UsersDashboard";
import DemandDashboard from "@/pages/DemandDashboard";
import HealthDashboard from "@/pages/HealthDashboard";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <AppShell>
                                        <FoundersDashboard />
                                    </AppShell>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/suppliers"
                            element={
                                <ProtectedRoute>
                                    <AppShell>
                                        <SuppliersDashboard />
                                    </AppShell>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/users"
                            element={
                                <ProtectedRoute>
                                    <AppShell>
                                        <UsersDashboard />
                                    </AppShell>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/demand"
                            element={
                                <ProtectedRoute>
                                    <AppShell>
                                        <DemandDashboard />
                                    </AppShell>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/health"
                            element={
                                <ProtectedRoute>
                                    <AppShell>
                                        <HealthDashboard />
                                    </AppShell>
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#0A0A0A",
                            border: "1px solid rgba(255,255,255,0.08)",
                            color: "#FAFAFA",
                            fontFamily: "JetBrains Mono, monospace",
                            fontSize: "12px",
                        },
                    }}
                />
            </AuthProvider>
        </div>
    );
}

export default App;
